import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SCAMP_API } from 'src/environments/environment';
import { ClasseEquipamento, TipoDeEquipamento } from '../pages/domain/domain.model';
import { AccountService } from './account.service';
import { CommandResult } from '../pages/domain/commandResult';


@Injectable({ providedIn: 'root' })
export class ClasseEquipamentoService {

    url = '';

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) {
        this.url = SCAMP_API.accountApiV1;
    }

    getById(id: number): Observable<ClasseEquipamento> {
        return this.http.get<ClasseEquipamento>(`${this.url}/classe-equipamento/${id}`,
            { headers: this.account.composeHeaders() });
    }

    getAll(): Observable<ClasseEquipamento[]> {
        return this.http.get<ClasseEquipamento[]>(`${this.url}/classe-equipamentos`,
        { headers: this.account.composeHeaders() });
    }

    save(model: ClasseEquipamento): Observable<CommandResult> {
        return this.http.post<CommandResult>(`${this.url}/classe-equipamento`, model,
        { headers: this.account.composeHeaders() });
    }

    isUniqueDescricao(descricao: string, id: number): Observable<boolean> {
        return this.http.get<boolean>(`${this.url}/classe-equipamento/isunique-descricao/${descricao}/${id}`,
            { headers: this.account.composeHeaders() });
    }

    delete(id: number): Observable<CommandResult> {
        return this.http.delete<CommandResult>(`${this.url}/classe-equipamento/${id}`, { headers: this.account.composeHeaders() });
    }

    

}
